import React, { ComponentProps } from 'react'
import { useRouter } from 'hooks/useRouter'
import { Button } from 'components/Button'
import { Link } from 'components/Link'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { MenuSection } from '../DesktopMenu/DesktopMenu'
import { LinkItem, NonCollapsibleMenuRoot } from './NonCollapsibleMenu.styles'

type NonCollapsibleMenuOwnProps = ComponentProps<typeof NonCollapsibleMenuRoot>

export type NonCollapsibleMenuProps = NonCollapsibleMenuOwnProps &
  MenuSection & {
    activeSection: string
  }

export const NonCollapsibleMenu = ({
  title,
  items,
  cta,
  activeSection,
}: NonCollapsibleMenuProps) => {
  const { t } = useTranslation()
  const { asPath } = useRouter()
  const basePath = asPath.split('?')[0]

  return (
    <NonCollapsibleMenuRoot active={title === activeSection}>
      <Text size="headline" weight="bold" color="accent-black" style={{ width: '100%' }}>
        {title}
        <Stack as="nav" direction="column" gap="3" aria-label={title}>
          <Stack as="ul" role="list" direction="column">
            {items?.map(({ label, url }, index) => (
              <Link key={index} href={url} passHref>
                <LinkItem active={url === basePath }>
                  <Text as="a" weight="bold">
                    {label}
                  </Text>
                </LinkItem>
              </Link>
            ))}
          </Stack>
          {cta && (
            <Button
              as="a"
              size="small"
              variant={cta.label === t('my-account:menu.pets.cta') ? 'primary' : 'secondary'}
              href={cta.url}
              css={{ marginBottom: '$1' }}
            >
              {cta.label}
            </Button>
          )}
        </Stack>
      </Text>
    </NonCollapsibleMenuRoot>
  )
}

NonCollapsibleMenu.displayName = 'NonCollapsibleMenu'
